import { loadStripe } from "@stripe/stripe-js";
import globalConfig from "@/config/config.js";

// Initialize Stripe with the provided key
// export const stripe = await loadStripe(globalConfig.stripeKey);

let stripeInstance = null;

export async function getStripeInstance() {
  if (!stripeInstance) {
    stripeInstance = await loadStripe(globalConfig.stripeKey);
  }
  return stripeInstance;
}
// 处理3D Secure支付验证
export const stripe3DS = async (data) => {
  try {
    // 调用Stripe的confirmCardPayment方法进行支付确认
    const stripe = await getStripeInstance();
    const res = await stripe.confirmCardPayment(data.stripe_client_secret);

    // 判断支付结果并返回相应的状态和数据
    if (res.paymentIntent) {
      return { status: 200, data: res.paymentIntent };
    } else if (res.error) {
      return { status: 400, data: res.error };
    } else {
      return { status: 500, data: "Unknown error occurred" }; // 处理未预见的错误情况
    }
  } catch (error) {
    console.error("Error confirming payment:", error);
    return { status: 500, data: error.message || "Internal Server Error" };
  }
};
